<template>
  <div class="maskBox">
    <div class="overSuccessful">
      <div class="oneSpinChance">{{$t('lang.cashWheel.oneSpinChance')}}</div>
      <div class="goTryYourLuck">{{$t('lang.cashWheel.goTryYourLuck')}}</div>
      <img class="OverSuccessfulUserList" src="../../assets/images/cashWheel/OverSuccessfulUserList.png" alt="">
      <div class="overSuccessfulTip">{{$t('lang.cashWheel.overSuccessful')}}</div>
      <div class="btn" :style="{ backgroundImage: 'url(' + require('../../assets/images/cashWheel/btnBg.png') + ')' }" @click="close()">Go</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-overSuccessful',
  methods: {
    close () {
      this.$emit('closeModalOverSuccessful')
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes expandInOut {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overSuccessful{
  background-size: 100% 100%;
  width: 93.33vw;
  height: 100.55vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5vw;
  animation: expandInOut 0.2s ease-out forwards;
  border: 1px solid #888888;
  border-right: 2px solid #888888;
  border-left: 2px solid #888888;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 1.243vw;
  .oneSpinChance{
    font-size: 6.38vw;
    font-weight: 700;
    font-family: 'Inter';
    font-style: normal;
    /* identical to box height, or 129% */
    text-align: center;
    text-transform: capitalize;
    background: linear-gradient(90deg, #F3F396 0%, #8CEBE3 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    text-shadow: 0px 0px 2.666vw rgba(255, 255, 255, 0.43);
  }
  .goTryYourLuck{
    color: #C9C9C9;
    font-size: 4.44vw;
  }
  .OverSuccessfulUserList{
    width: 68.4vw;
    height: 28.07vw;
  }
  .overSuccessfulTip{
    color: #fff;
    font-size: 4.44vw;
    font-weight: 700;
    width: 57.72vw;
    text-align: center;
    letter-spacing: 0.4vw;
  }
  .btn{
    width: 81.913vw;
    height: 10.833vw;
    //background-color: #FFD84D;
    background-size: 100% 100%;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.22vw;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-overSuccessful.vue